// Authentication & User
export const LOGIN_COOKIE_NAME = "rs_session_cookie";
export const LOGIN_COOKIE_USERID = "rs_session_userid";
export const LOGIN_TOKEN_RANDOM = "rs_session_random";
export const USER_INFO = "user_info";
export const USER_ADDRESS = "userAddress";
export const USER_LOGGED_IN = "isUserLoggedIn";

//Orders 
export const ORDER_INTERNAL_SALE = "internal_sale";